var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    ref: "recaptcha",
    staticClass: "g-recaptcha",
    class: [_vm.lang, _vm.location],
    attrs: { "data-sitekey": _vm.siteKey },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }